import { Injectable } from '@angular/core';
import { DataService } from 'src/api/services/data.service';
import { BehaviorSubject, Observable } from "rxjs";
import { DataBusLicense } from 'src/api/models/data-bus-license';
import { ApiConfiguration } from 'src/api/api-configuration';
import { BaseEvent} from 'src/api/models/base-event';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { AzureAuthService } from 'src/service/azure-auth.service';

@Injectable()
export class AbstractDataService {
  
  private http: HttpClient;
  private openService : DataService;

  //private registered : {} = {};
  private register: { [uri: string] : any[]; } = {};

  constructor(private readonly service: DataService, private readonly httpHandler: HttpBackend, public authService: AzureAuthService,) {
    this.http = new HttpClient(httpHandler);
    this.openService = new DataService(new ApiConfiguration(), this.http);
  }

  /*dashboardGet(params: DataService.DataDashboardGetParams) {
    //if (document.URL.indexOf('/public/') >= 0 || document.URL.indexOf('/embed/') >= 0){
    if (this.authService.anon){
      return this.openService.DataDashboardGet(params);
    }
    else {
      return this.service.DataDashboardGet(params);
    }
  }*/

  dashboardGets(params: DataService.DataDashboardGetsParams) {
    //if (document.URL.indexOf('/public/') >= 0 || document.URL.indexOf('/embed/') >= 0){
    if (this.authService.anon){
      return this.openService.DataDashboardGets(params);
    }
    else {
      return this.service.DataDashboardGets(params);
    }
  }

  publishData(uri: string, data: any){
    //console.log(data);
    if (data && data.Point && data.Point.Value){
      var actions = this.register[uri];
      if (actions){
        for (let action of actions){
          action({uri: uri, point: { value: data.Point.Value, timeStamp : data.Point.TimeStamp }});
        }
      }
    } else if (data.Values && data.Values.length == 0) {
      console.log("Live data received with no Point(s)", data)
    } else if (data.Values && data.Values.length > 0){
      var actions = this.register[uri];
      if (actions){
        var point = data.Values[data.Values.length - 1];
        for (let action of actions){
          action({uri: uri, point: { value: point.Value, timeStamp : point.TimeStamp }});
        }
      }
    }
  }

  publishValue(uri:string, value){
    //console.log(value);
    var actions = this.register[uri];
    if (actions){
      for (let action of actions){
        action({uri: uri, point: {value:value, timeStamp: new Date()}});
      }
    }
  }

  clear(){
    this.register = {};
  }

  registerForLiveData(uri: string, action){
    console.log("Registered for Live Data:" + uri);
    if (this.register[uri] == null){
      this.register[uri] = [];
    }
    this.register[uri].push(action);
  }

}
